import loadable from '@loadable/component';
import React, {useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {FlatList, Linking, Text, View} from 'react-native';
import {useMutation} from 'react-query';
import {useDispatch, useSelector} from 'react-redux';
import {showAlert} from '../../../../actions/AlertActions';
import {showSheet} from '../../../../actions/SheetActions';
import {getVehicle} from '../../../../actions/vehicle';
import {getVehicleslist} from '../../../../actions/vehicleslist';
import CustomBottomSheet from '../../../../components/bottom-sheet';
import PrimaryButton from '../../../../components/primary-button/PrimaryButton.component';
import {endTripErrors, isWeb, windowHeight} from '../../../../constants';
import {useHistory} from '../../../../imports/Router';
import {useApi} from '../../../../providers/ApiProvider';
import {selectconfigtype} from '../../../../selectors/config';
import {selecetmaptype} from '../../../../selectors/Map';
import {selectrootsheettype} from '../../../../selectors/SheetSelector';
import {selecetvehivletype} from '../../../../selectors/Vehicle';
import {AnalyticsEvent} from '../../../../services/analytics/FirebaseAnalytics';
import {
  checkLocationIsValid,
  checkPermitionAndGetPosition,
} from '../../../../utils/location';
import ErrorBox from './components/ErrorBox.component';
import styles from './EndTripErrorSheet.style';
import {BottomSheetScrollView} from '@gorhom/bottom-sheet';
import {selecetusertype} from '../../../../selectors/User';
import {getUser} from '../../../../actions/user';
import {getModal} from '../../../../actions/modal';
import Sentry from 'src/imports/sentry';
import LottieView from 'src/imports/Lottie';
const SVG = loadable(() => import('../../../../imports/svg'));

const WrappperList = ({children}) => {
  if (isWeb) {
    return children;
  } else {
    return <BottomSheetScrollView>{children}</BottomSheetScrollView>;
  }
};

export default function EndTripErrorSheet() {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const {api} = useApi();
  const bottomSheetRef = useRef(null);
  const {sheetId, sheetProps} = useSelector(state =>
    selectrootsheettype(state),
  );
  const errorList = sheetProps?.errorList ?? [];
  const {vehicle, tripId} = useSelector(state => selecetvehivletype(state));
  const {max_allowed_accuracy} = useSelector(state => selectconfigtype(state));
  const {userPosition} = useSelector(state => selecetmaptype(state));
  const [isBottomSheetVisible, setIsBottomSheetVisible] = useState(false);
  const {endTripImageIds} = useSelector(state => selecetusertype(state));
  const {supportPhone} = useSelector(state => state?.config);
  const {retryEndTrip = () => {}} = sheetProps || {};
  const ImageIds = useSelector(state => state.user.endTripImageIds);
  const isFirstTry2 = useSelector(state => state?.app?.isFirstTry);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    switch (sheetId) {
      case 'endTripError':
        openHandler();
        break;
      default:
        closeHandler();
        break;
    }
  }, [sheetId]);

  function openHandler() {
    setIsBottomSheetVisible(true);
    if (isWeb) return;
    bottomSheetRef.current?.expand();
  }

  function closeHandler() {
    setTimeout(() => {
      setIsBottomSheetVisible(false);
    }, 400);
    dispatch(showSheet({sheetId: ''}));
    switch (isWeb) {
      case true:
        bottomSheetRef?.current?.snapTo(() => 0);
        break;
      case false:
        bottomSheetRef.current?.close();
        break;
      default:
        break;
    }
  }

  function onRequestClose() {
    dispatch(showSheet({sheetId: ''}));
  }

  function renderItem({item}) {
    return <ErrorBox item={item} />;
  }

  //invalid location
  const dashboardInvalidLocationMutation = useMutation({
    mutationFn: async body => {
      return api.dashboardInvalidLocation(body);
    },
  });

  const distanceNotValidHandler = () => {
    let errorMessage = '';
    let vehicle_type = vehicle?.type === 'Bike' ? 'motor' : 'bike';
    checkPermitionAndGetPosition({
      onSuccess: position => {
        if (Number(position?.coords?.accuracy) > Number(max_allowed_accuracy)) {
          dashboardInvalidLocationMutation.mutate({
            Lat: position.coords?.latitude,
            Long: position.coords?.longitude,
            Accuracy: position?.coords?.accuracy,
          });
          errorMessage = 'location_accuracy_error';
        } else {
          errorMessage = `approach_${vehicle_type}`;
        }
        dispatch(
          showAlert({
            id: 'AlertBox',
            modalProps: {
              icon: 'redExclamation',
              title: t(errorMessage),
            },
          }),
        );
      },
      onError: err => {
        if (err.code !== 1) {
          if (Number(userPosition?.accuracy) > Number(max_allowed_accuracy)) {
            dashboardInvalidLocationMutation.mutate({
              Lat: userPosition?.lat ?? 0,
              Long: userPosition?.lng ?? 0,
              Accuracy: userPosition?.accuracy ?? 0,
            });
            errorMessage = 'location_accuracy_error';
          } else {
            errorMessage = `approach_${vehicle_type}`;
          }
          dispatch(
            showAlert({
              id: 'AlertBox',
              modalProps: {
                icon: 'redExclamation',
                title: t(errorMessage),
              },
            }),
          );
        }
      },
    });
  };

  //end trip
  const tripsEndMutation = useMutation({
    mutationFn: async body => {
      return api.TripsEnd(body);
    },
    onSuccess: response => {
      let params = response?.Data;
      params.id = tripId;
      history.replace({
        pathname: '/payment',
        state: {data: params},
      });
      closeHandler();
      dispatch(
        getUser({
          endTripImageIds: [],
        }),
      );
      dispatch(
        showSheet({
          sheetId: '',
          sheetProps: {},
        }),
      );
      dispatch(
        getVehicle({
          activeSeconds: 0,
          pauseSeconds: 0,
          activeMinutes: 0,
          pauseMinutes: 0,
          stop: false,
        }),
      );
      dispatch(getVehicleslist({type: 'both'}));
      AnalyticsEvent({
        type: 'trip',
        params: {
          trip_action: 'end_trip',
          trip_vehicle_type:
            vehicle?.type === 'Bicycle'
              ? 'bicycle'
              : vehicle?.type === 'Bike'
              ? 'motor'
              : vehicle?.type === 'Scooter'
              ? 'scooter'
              : '',
          trip_id: tripId,
        },
      });
    },
    onError: error => {
      let error_types = error?.response?.data?.Result ?? [];
      const status = error?.response?.status;
      const errorMesage =
        error?.message === 'Network Error'
          ? 'Network Error'
          : error_types.join('|');
      Sentry.setTag('api_error', 'end_trip');
      Sentry.captureMessage(`Error ending trip ${errorMesage} - ${status}`);
      error_types = error_types.filter(item => endTripErrors.includes(item));
      if (error_types.length == 0) {
        error_types = ['unknown_error_end_trip'];
      } else if (error_types.includes('NotFound')) {
        dispatch(showSheet({sheetId: ''}));
        history.push('/main/map');
        const data = {
          modal: true,
          image: 'endTripIcon',
          width: 88,
          height: 60,
          text: '',
          Notification: true,
          func: 'tripended',
          number: t('admin_end_trip'),
        };
        dispatch(getModal(data));
        dispatch(
          getVehicle({
            activeSeconds: 0,
            pauseSeconds: 0,
            activeMinutes: 0,
            pauseMinutes: 0,
            stop: false,
          }),
        );
        dispatch(getVehicleslist({type: 'both'}));
        dispatch(getUser({notificationmodal: true}));
      } else if (
        error_types.length === 1 &&
        error_types[0] === 'HelmetLockIsNotLocked'
      ) {
        dispatch(getUser({needUploadImage: false}));
        dispatch(
          showSheet({
            sheetId: 'endTripError',
            sheetProps: {
              isFirstTry: false,
              errorList: error_types,
            },
          }),
        );
      } else {
        if (error_types.includes('Error_Distance_not_valid')) {
          distanceNotValidHandler();
        }
        dispatch(
          showSheet({
            sheetId: 'endTripError',
            sheetProps: {
              isFirstTry: false,
              errorList: error_types,
            },
          }),
        );
      }
    },
  });

  //retry tack photo, upload and trips end
  function endTripHandler() {
    setIsLoading(true);
    checkPermitionAndGetPosition({
      onSuccess: position => {
        tripsEndMutation.mutate(
          {
            tripId: tripId,
            Latitude: position.coords?.latitude,
            Longitude: position.coords?.longitude,
            EndTripImageIds: endTripImageIds,
            IsCheck: false,
          },
          {
            onSettled: () => setIsLoading(false), // ✅ پایان لودینگ
          },
        );
      },

      onError: err => {
        if (err.code !== 1) {
          const locationIsValid = checkLocationIsValid(
            userPosition?.timestamp ?? 0,
            2,
          );
          tripsEndMutation.mutate(
            {
              tripId: tripId,
              Latitude: locationIsValid ? userPosition?.lat : 0,
              Longitude: locationIsValid ? userPosition?.lng : 0,
              EndTripImageIds: endTripImageIds,
              IsCheck: false,
            },
            {
              onSettled: () => setIsLoading(false), // ✅ پایان لودینگ
            },
          );
        }
      },
    });
  }

  function goMapHandler() {
    if (
      errorList.length === 1 &&
      errorList[0] === 'HelmetLockIsNotLocked' &&
      vehicle?.Brand === 3
    ) {
      setIsLoading(false);
      endTripHandler();
    } else {
      closeHandler();
      history.replace('/main/map/drive');
    }
  }

  const callNumber = number => {
    Linking.openURL(`tel:${number}`);
  };

  if (isBottomSheetVisible) {
    return (
      <CustomBottomSheet
        onClose={onRequestClose}
        ref={bottomSheetRef}
        enablePanDownToClose={isWeb ? undefined : false}
        expandOnContentDrag={isWeb ? false : undefined}
        snapPoints={
          isWeb
            ? ({minHeight}) => [1, windowHeight * 0.8]
            : [windowHeight * 0.8]
        }
        onSpringEnd={
          isWeb
            ? () => {
                if (bottomSheetRef?.current?.height < 2) {
                  dispatch(showSheet({sheetId: ''}));
                }
              }
            : undefined
        }
        defaultSnap={isWeb ? windowHeight * 0.8 : undefined}
        open={isBottomSheetVisible}
        scrollViewStyle={isWeb ? undefined : styles.scroll}
        blocking={isWeb ? true : undefined}
        scrollLocking={isWeb ? false : undefined}>
        <View style={styles.content}>
          <View>
            {sheetProps?.isFirstTry && (
              <View style={styles.mainIcon}>
                <SVG name={'endTripError'} width={44.44} height={44} />
              </View>
            )}
            <Text style={styles.mainTitle}>
              {t(
                sheetProps?.isFirstTry || errorList.length == 0
                  ? 'problem_at_end_trip'
                  : 'to_finish_trip_first_solve_problems',
              )}
            </Text>
          </View>
          <WrappperList>
            {console.log(errorList, 'errorList FlatList')}
            <FlatList
              data={errorList}
              renderItem={renderItem}
              keyExtractor={item => item?.id}
            />
          </WrappperList>
          <View>
            {!sheetProps?.isFirstTry && (
              <PrimaryButton
                title={t('contact_support')}
                containerStyle={styles.checkButton}
                textStyle={styles.checkButtonTitle}
                onPress={() => callNumber(supportPhone?.replace('-', ''))}
                isLight={true}
              />
            )}
            <PrimaryButton
              title={
                errorList.length === 1 &&
                errorList[0] === 'HelmetLockIsNotLocked' &&
                vehicle?.Brand === 3
                  ? t('end_trip')
                  : t('i_realized')
              }
              containerStyle={styles.mapButton}
              onPress={() => {
                goMapHandler();
              }}
              error={errorList[0]}
              isLoading={isLoading}
            />
          </View>
        </View>
      </CustomBottomSheet>
    );
  } else {
    return null;
  }
}
